import { useEffect, useState } from "react";
import { api } from "../lib/api";

const EU = new Set(["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT",
  "LV", "LT", "LU", "MT", "NL", "PL", "RO", "SK", "SI", "ES", "SE"]);

let cache = null;
const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();

export function useCountries() {
  const [items, setItems] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    api.get("/countries").then(({ data }) => { cache = data.items; setItems(cache); }).catch(() => {});
  }, []);
  return items;
}

export const findCountry = (items, value) => {
  const v = norm(value);
  return items.find((c) => norm(c.pt) === v || norm(c.en) === v || norm(c.code) === v);
};

/** Client-side address checks mirroring the backend (clear PT messages). */
export function validateBillingAddress({ country, address, city, postal_code, nif }, items) {
  const c = findCountry(items, country || "Portugal");
  if (items.length && !c) return `País «${country}» não reconhecido — escolha da lista.`;
  const isPt = !c || c.code === "PT";
  if (isPt) {
    if (postal_code && !/^\d{4}-\d{3}$/.test(postal_code.trim())) return "Código postal português inválido — use o formato 0000-000.";
    const d = (nif || "").replace(/[\s.-]/g, "").replace(/^PT/i, "");
    if (d && !/^\d{9}$/.test(d)) return "O NIF português tem de ter 9 dígitos (ou deixe vazio para Consumidor Final).";
    return null;
  }
  const missing = [["morada", address], ["cidade", city], ["código postal", postal_code]].filter(([, v]) => !(v || "").trim()).map(([l]) => l);
  if (missing.length) return `Cliente com morada em ${c.pt}: indique ${missing.join(", ")}.`;
  return null;
}

/** Country picker with the Facturalusa-accepted list (PT names). */
export default function CountrySelect({ value, onChange, className = "", testId }) {
  const items = useCountries();
  const current = findCountry(items, value);
  const selected = current ? current.pt : value || "Portugal";
  const eu = items.filter((c) => EU.has(c.code));
  const rest = items.filter((c) => c.code !== "PT" && !EU.has(c.code));
  return (
    <select value={selected} onChange={(e) => onChange(e.target.value)} className={className} data-testid={testId}>
      {!current && value && items.length > 0 && <option value={value}>{value} (não reconhecido)</option>}
      {!items.length && value && value !== "Portugal" && <option value={value}>{value}</option>}
      <option value="Portugal">Portugal</option>
      <optgroup label="União Europeia">
        {eu.map((c) => <option key={c.code} value={c.pt}>{c.pt}</option>)}
      </optgroup>
      <optgroup label="Outros países">
        {rest.map((c) => <option key={c.code} value={c.pt}>{c.pt}</option>)}
      </optgroup>
    </select>
  );
}
